import { CustomerFields } from '../PersonsFields'

export const CustomerStep = () => {
  return <CustomerFields isEditable />
}
